module.exports = __webpack_public_path__ + "static/media/HCMM872.7e745f87.jpg";